import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import moment from 'moment'

import { ApplicationState } from 'src/store'
import { Text } from 'src/components/atoms'

import {
  WarpTitleNps,
  WrapNpsTop,
  WrapPeriod,
  WrapSectionHeader
} from './styles'
import { PieChart, BarLineChart, BarColumnChart } from '..'

const initialValues = {
  DetractorPercent: 0,
  DetractorTotal: 0,
  ended_on: 0,
  NeutralPercent: 0,
  NeutralTotal: 0,
  NPS: 0,
  position1: 0,
  position10: 0,
  position2: 0,
  position3: 0,
  position4: 0,
  position5: 0,
  position6: 0,
  position7: 0,
  position8: 0,
  position9: 0,
  PromoterPercent: 0,
  PromoterTotal: 0,
  started_on: 0
}

function SectionHeader() {
  const {
    reports: {
      reportsResources: {
        R9Header: { data: header }
      }
    }
  } = useSelector((state: ApplicationState) => ({
    reports: state.reports
  }))

  const chartValues = useMemo(() => {
    let values = { ...initialValues }
    header.forEach(rec => {
      switch (rec.id) {
        case 'STARTED_ON':
          values.started_on = rec.info
          break
        case 'ENDED_ON':
          values.ended_on = rec.info
          break
        case 'PROMOTER':
          values.PromoterPercent = rec.info
          values.PromoterTotal = rec.quantity
          break
        case 'NEUTRAL':
          values.NeutralPercent = rec.info
          values.NeutralTotal = rec.quantity
          break
        case 'DETRACTOR':
          values.DetractorPercent = rec.info
          values.DetractorTotal = rec.quantity
          break
        case 'TOTAL':
          values = {
            ...values,
            [`position${rec?.info > -1 ? rec.info : '0'}`]: rec.quantity
          }
      }
    })
    return {
      ...values,
      NPS:
        Number((values.PromoterPercent - values.DetractorPercent).toFixed(2)) ||
        0
    }
  }, [header])

  const defaultInfo = ' - '

  const startedOn =
    moment
      .unix(chartValues.started_on)
      .utc()
      .format('DD/MM/YYYY') || defaultInfo
  const endedOn =
    moment
      .unix(chartValues.ended_on)
      .utc()
      .format('DD/MM/YYYY') || defaultInfo

  const periodo = `Período ${startedOn} - ${endedOn}`
  return (
    <WrapSectionHeader>
      <WrapNpsTop>
        <div>
          <WarpTitleNps>
            <Text text="common.nps.chart.overview" />
          </WarpTitleNps>
          <PieChart nps={chartValues.NPS} />
        </div>
        <div>
          <BarLineChart
            detractorPercent={chartValues.DetractorPercent}
            detractorTotal={chartValues.DetractorTotal}
            neutralPercent={chartValues.NeutralPercent}
            neutralTotal={chartValues.NeutralTotal}
            promoterPercent={chartValues.PromoterPercent}
            promoterTotal={chartValues.PromoterTotal}
          />
        </div>
        <div>
          <BarColumnChart
            position1={chartValues.position1}
            position10={chartValues.position10}
            position2={chartValues.position2}
            position3={chartValues.position3}
            position4={chartValues.position4}
            position5={chartValues.position5}
            position6={chartValues.position6}
            position7={chartValues.position7}
            position8={chartValues.position8}
            position9={chartValues.position9}
          />
        </div>
      </WrapNpsTop>
      <WrapPeriod>{periodo}</WrapPeriod>
    </WrapSectionHeader>
  )
}

export default SectionHeader
